var styles = {"box":"Background_box_8hmf1_9","normal":"Background_normal_8hmf1_17","green":"Background_green_8hmf1_25","yellow":"Background_yellow_8hmf1_25","green2":"Background_green2_8hmf1_37","hover":"Background_hover_8hmf1_41","active":"Background_active_8hmf1_48","shine":"Background_shine_8hmf1_64","star":"Background_star_8hmf1_76","star-active":"Background_star-active_8hmf1_89"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
